<template>
  <van-popup v-if="firstLoad" v-model="popShow" :close-on-click-overlay="false" position="bottom">
    <div ref="popupRef" class="verify_popup">
      <div v-show="showSlideVerification" id="slideVerification2" class="slide_verification"></div>
      <div v-if="popShow && !showSlideVerification">
        <div class="title">{{ title }}</div>
        <div class="account">{{ curVerifyType === 'EMAIL' ? email : '+' + phone }}</div>
        <CommonInput
          v-model="smsCode"
          type="tel"
          inputmode="numeric"
          :placeholder="curVerifyType == 'PHONE' ? $t('common.smsCode') : $t('common.emailCode')"
          theme="white"
          :max-length="VALID_CODE_LENGTH"
          auto-focus
        >
          <div class="send_span" :class="msgValidating && 'disabled'" @touchend.stop.prevent="resend">
            {{ !msgValidating ? (firstSendMsg ? $t('common.send') : $t('common.resend')) : this.count + 's' }}
          </div>
        </CommonInput>
        <CommonBtn class="next_btn" :text="$t('common.next')" :disabled="!smsCode" :on-click="tryLogin" />
        <div
          v-show="curVerifyType !== 'EMAIL' && emailBtnShow"
          class="switch_verify_type"
          @click="() => changeCurVerifyType('EMAIL')"
        >
          {{ $t('loginAndRegister.verifyEmail') }}
        </div>
        <div
          v-show="curVerifyType !== 'PHONE' && phoneBtnShow"
          class="switch_verify_type"
          @click="() => changeCurVerifyType('PHONE')"
        >
          {{ $t('loginAndRegister.verifyPhone') }}
        </div>
      </div>
    </div>
  </van-popup>
</template>

<script>
import CommonInput from '@/components/CommonInput'
import CommonBtn from '@/components/CommonBtn.vue'
import { Toast } from 'vant'
import throttle from 'lodash/throttle'
import { isInWebView } from '@/utils'
import { VALID_CODE_LENGTH } from '@/utils/constants'

export default {
  name: 'LoginVerifyPopup',
  components: {
    CommonInput,
    CommonBtn
  },
  props: {
    value: Boolean,
    emailBtnShow: Boolean,
    phoneBtnShow: Boolean,
    type: String,
    email: String,
    phone: String,
    areaCode: String | Number
  },
  data() {
    return {
      VALID_CODE_LENGTH,
      firstLoad: false,
      popShow: false,
      smsCode: '',
      showSlideVerification: false,
      curVerifyType: '',
      msgValidating: false,
      count: 59,
      firstSendMsg: true,
      interval: undefined,
      toWhatsapp: false
    }
  },
  computed: {
    title() {
      return this.curVerifyType === 'EMAIL'
        ? this.$t('redesign.sendToEmail')
        : this.toWhatsapp
          ? this.$t('redesign.sendToWhatsapp')
          : this.$t('redesign.sendToPhone')
    }
  },
  watch: {
    value(val) {
      this.popShow = val
      if (val) {
        this.firstLoad = true
        this.curVerifyType = this.type
        if (this.type === 'PHONE') {
          this.showSlideVerification = true
        } else {
          this.sendSmsCode()
        }
        if (isInWebView()) {
          document.addEventListener('touchstart', this.checkInputFocus)
          this.checkInputFocus()
        }
      } else {
        if (isInWebView()) {
          document.removeEventListener('touchstart', this.checkInputFocus)
        }
      }
    },
    popShow(val) {
      this.$emit('input', val)
    },
    firstLoad(val) {
      if (val) {
        this.initSlideVerification()
      }
    },
    smsCode(val) {
      if (val.length === this.VALID_CODE_LENGTH) {
        this.tryLogin()
      }
    }
  },
  methods: {
    checkInputFocus() {
      setTimeout(() => {
        if (document.activeElement.tagName === 'INPUT') {
          this.$refs.popupRef.style.paddingBottom = '35vh'
        } else {
          this.$refs.popupRef.style.paddingBottom = '0.24rem'
        }
      }, 200)
    },
    initSlideVerification() {
      const $this = this
      initSMCaptcha(
        {
          organization: '90I5YRBCdvRoD8mXmETq',
          domains: ['captcha-xjp.fengkongcloud.cn'], // 新加坡
          product: 'embed', // 展现形式
          appendTo: 'slideVerification2', // 指定 DOM 节点
          mode: 'slide', // 验证码模式
          lang: 'en',
          width: 295,
          style: {
            slideBar: {
              color: '#3FBB70',
              successColor: '#3FBB70',
              border: 'none',
              process: {
                background: '#3FBB7033',
                failBackground: '#ff4c6233'
              },
              button: {
                boxShadow: 'none',
                background: '#3FBB70',
                failBackground: '#ff4c62'
              }
            }
          }
        },
        (SMCaptcha) => {
          SMCaptcha.onSuccess(function (data) {
            if (data.pass) {
              $this.showSlideVerification = false
              SMCaptcha.reset()
              $this.sendSmsCode(data.rid)
            }
          })
        }
      )
    },
    changeCurVerifyType(type) {
      this.curVerifyType = type
      if (type === 'PHONE') {
        this.showSlideVerification = true
        clearInterval(this.interval)
        this.msgValidating = false
        this.count = 59
        this.smsCode = ''
      } else if (type === 'EMAIL') {
        this.showSlideVerification = false
        clearInterval(this.interval)
        this.msgValidating = false
        this.count = 59
        this.sendSmsCode()
        this.smsCode = ''
      }
    },
    sendSmsCode(rid = '') {
      if (this.msgValidating) {
        return
      }
      let isEmail = this.curVerifyType === 'EMAIL'
      const $this = this
      const phone = this.phone
      const email = this.email
      const url = window.serverPath + (isEmail ? '/api/auth/getNewEmailCode/LOGIN' : '/api/auth/getNewSmsCode/LOGIN')
      let params = {
        email: '',
        phone: '',
        areaCode: this.areaCode,
        rid: rid
      }
      if (this.isMasked(phone) && !this.isMasked(email)) {
        // 手机脱敏邮箱正常
        params.email = email
      } else if (!this.isMasked(phone) && this.isMasked(email)) {
        // 邮箱脱敏手机正常
        params.phone = phone
      } else {
        // 正常登录
        if (isEmail) {
          params.email = email
        } else {
          params.phone = phone
        }
      }
      if (phone || email) {
        this.$http
          .post(url, params)
          .then((res) => {
            if (res.data.code === '200') {
              $this.msgValidating = true
              $this.firstSendMsg = false
              $this.toWhatsapp = res.data.data === 'WhatsApp'
              $this.interval = window.setInterval(() => {
                $this.count -= 1
                if ($this.count <= 0) {
                  clearInterval($this.interval)
                  $this.msgValidating = false
                  $this.count = 59
                }
              }, 1000)
            } else if (res.data.code === '40001') {
              Toast({
                message: this.$t('loginAndRegister.userNotExistToast')
              })
            } else {
              Toast({
                message: res.data.message
              })
            }
          })
          .catch((_err) => {
            console.log('异常')
            $this.msgValidating = false
            $this.count = 59
          })
      } else {
        Toast({ message: this.$t('loginAndRegister.phoneIncorrectToast') })
      }
    },
    isMasked(str) {
      return str.indexOf('*') !== -1
    },
    resend() {
      if (this.msgValidating) {
        return
      }
      if (this.curVerifyType === 'EMAIL') {
        this.sendSmsCode()
      } else {
        this.showSlideVerification = true
      }
    },
    tryLogin: throttle(
      function () {
        this.$emit('tryLogin', this.smsCode, this.curVerifyType)
      },
      5000,
      { trailing: false }
    )
  }
}
</script>

<style scoped>
.verify_popup {
  padding: 0.24rem;
  background: #fff;
  border-radius: 0.16rem 0.16rem 0 0;
  position: relative;
}

.slide_verification {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  height: 100%;
  overflow: hidden;
}

.title {
  display: flex;
  color: #2f2f2f;
  font-family: 'PingFang SC';
  font-size: 0.2rem;
  font-style: normal;
  font-weight: 600;
  line-height: 0.28rem;
  margin-bottom: 0.04rem;
  max-width: calc(100% - 0.4rem);
}

.account {
  display: flex;
  color: #3fbb70;
  font-family: 'PingFang SC';
  font-size: 0.14rem;
  font-style: normal;
  font-weight: 600;
  line-height: 0.22rem;
  margin-bottom: 0.2rem;
  direction: ltr;
}

.send_span {
  color: #3fbb70;
  font-size: 0.14rem;
  font-family: 'PingFang SC';
  font-style: normal;
  font-weight: 400;
  line-height: 0.22rem;
  white-space: nowrap;
}

.send_span.disabled {
  color: #828282;
}

.next_btn {
  margin: 0.48rem auto 0.12rem;
  font-size: 0.16rem !important;
}

.switch_verify_type {
  width: 100%;
  text-align: center;
  margin-bottom: 0.24rem;
  color: #3fbb70;
  font-family: 'PingFang SC';
  font-size: 0.14rem;
  font-style: normal;
  font-weight: 600;
  line-height: 0.22rem;
}
</style>



// WEBPACK FOOTER //
// src/components/Login/LoginVerifyPopup.vue